import React, { FC } from 'react';
import { Title } from '../developers/page-components/Title';

export const ContactDetailsPaymentMethods: FC = () => {
	return (
		<div className="card">
			<div className="card-body">
				<Title title="Payment methods" additionalClass="fs-5 fw-bolder" />
				<div className="h-100px d-flex align-items-center justify-content-center">
					No records to display
				</div>

			</div>
		</div>
	);
};